// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Ux6y","filesListContainer":"PosDisputesFiles_filesListContainer__3_4Q7","filesButton":"PosDisputesFiles_filesButton__3py42"};